<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.sections.length === 0"
  [emptyTitle]="'section.no-sections-title' | translate"
  [emptyDescription]="'section.no-sections-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="section-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && cycle$ | async as cycle">
    <mat-nav-list role="list" *ngIf="cycle?.sections?.length" class="section-overview__list">
      <a
        mat-list-item
        role="listitem"
        class="section-item"
        *ngFor="let section of sort(cycle.sections)"
        [attr.data-test]="'section-overview__item_' + section.id"
        (click)="openSectionEdit(section.id)"
      >
        <mat-icon
          matListItemIcon
          matListItemAvatar
          class="list-avatar"
          svgIcon="mdi-barn"
        ></mat-icon>
        <div matListItemTitle>{{ section?.name }}</div>
        <div matListItemLine class="text--gray">
          {{ section?.barn?.name }}
        </div>
        <div matListItemLine class="text--gray">
          {{ section.gender | translate }} {{ section.breed?.name }}
        </div>
        <button
          matListItemMeta
          mat-icon-button
          (click)="delete($event, section)"
          data-test="section-overview__delete-item"
        >
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="cycle.sections.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
